module.exports = __webpack_public_path__ + "static/pegasus-mtg_afr-f206599dedbd9f02b6e75ffb6befa42f.jpg";